module.exports = __webpack_public_path__ + "img/logo.da0dd146.png";